import { render, staticRenderFns } from "./TableListClientsOrganization.vue?vue&type=template&id=3eb4dd90"
import script from "./TableListClientsOrganization.vue?vue&type=script&lang=js"
export * from "./TableListClientsOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eb4dd90')) {
      api.createRecord('3eb4dd90', component.options)
    } else {
      api.reload('3eb4dd90', component.options)
    }
    module.hot.accept("./TableListClientsOrganization.vue?vue&type=template&id=3eb4dd90", function () {
      api.rerender('3eb4dd90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserDetail/TableListClientsOrganization.vue"
export default component.exports